import React from "react";
import "./MainImg.css";
import heroImg from "../../assets/pictures/HeroImg.jpg";

function MainImg() {
  return (
    <div
      className="HeroPart"
      style={{ backgroundImage: `url(${heroImg})` }}
      id="home"
    >
      <h1>
        YOUR TRUSTED HOME{" "}
        <span className="bluetext">MAINTENANCE</span> PARTNER
      </h1>

      <p>
        Need Electrical Repairs, Plumbing Solutions, HVAC services, Painting, Carpentry, Tiling, or general maintenance? Our skilled technicians are ready to deliver fast, reliable, and affordable solutions to keep your home in perfect condition.
      </p>

      <div className="HeroPart_buttons">
        {/* 📞 Call */}
        <button
          className="Hero_Callnow"
           onClick={() =>
    window.location.href = "tel:+971521743345"
  }
        >
          Call Now
        </button>

        {/* 💬 WhatsApp Get Quote */}
        <button
          className="Hero_SS"
          onClick={() =>
            window.open(
              "https://wa.me/971521743345?text=Hi%2C%20I%E2%80%99d%20like%20to%20request%20a%20quote%20for%20home%20maintenance%20services.",
              "_blank"
            )
          }
        >
          Get Quote
        </button>
      </div>
    </div>
  );
}

export default MainImg;